import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';
import { AuthService } from "src/app/security/auth.service";

@Injectable({
  providedIn: 'root'
})
export class Global {

  constructor(private authService: AuthService) { }

  timeLeft: number = 0;

  interval;

  startTimer() {
    this.timeLeft = parseInt(localStorage.getItem('inactividad'));

    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;

        if (this.timeLeft === parseInt(localStorage.getItem('tiempoMensaje'))) {
          Swal.fire({
            text: 'Su sesión está a punto de terminar\n¿Desea renovarla?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            buttonsStyling: false,
            timer: parseInt(localStorage.getItem('tiempoMensaje') || '0') * 1000,
          }).then((result) => {

            if (result.value) {
              this.authService.validateSesion().subscribe(res => {
                if (res.codigoDeRespuesta !== '00000') {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Su sesión ha caducado',
                    confirmButtonText: 'Aceptar',
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: 'btn btn-warning',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.authService.logout();
                      this.timeLeft = 0;
                    }
                  });
                } else {
                  this.timeLeft = parseInt(localStorage.getItem('inactividad'));
                }
              });
            } else {
              this.authService.logout();
              this.timeLeft = 0;
            }
          });
        }
      } else {
        this.pauseTimer();
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
  reinciarTimer() {
    this.pauseTimer();
    this.startTimer();
  }

}